import React from "react";
import ReactDom from "react-dom";
import "./index.css";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import * as Sentry from "@sentry/browser";
import { StateContextProvider } from "./contexts/ContextProvider";
import NavBar from "./components/NavBar/NavBar";

if (process.env.REACT_APP_ENV === "production") {
  // Catch errors
  Sentry.init({
    dsn: "https://0eb1499391824a32a4715058e8f220d5@app.glitchtip.com/1752",
  });
}

const theme = createTheme({
  palette: {
    mode: "dark",
  },
});

ReactDom.render(
  <StateContextProvider>
    <ThemeProvider theme={theme}>
      <NavBar />
      <App />
    </ThemeProvider>
  </StateContextProvider>,
  document.getElementById("root")
);
